import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Placeholder from '../assets/thumbnails/rapid-boost.jpeg';
import Shine from '../assets/Shine.svg'

const Pricing = () => {
    const navigate = useNavigate();

    // Melee Academy — Resources
    const resources = {
      "SSBM Tutorials": {
        title: "SSBM Tutorials",
        description:
          "Beginner-friendly video guides covering core Melee basics and mechanics—great jumping-off point for new players.",
        url: "https://www.youtube.com/ssbmtutorials"
      },
      "LloD's Guide": {
        title: "LloD’s Guide to Improvement",
        description:
          "Deep, text-based improvement framework from a top player—best after you’ve absorbed foundational videos.",
        url: "https://docs.google.com/document/d/1xwPP5AgM_qw6AIwGnP2t7n2hlyb3j2K--JDMlOPx_bA/edit?tab=t.0"
      },
      "KoDoRiN's Guide": {
        title: "KoDoRiN’s Fundamentals Guide",
        description:
          "Advanced fundamentals and structured practice advice—pairs well with serious VOD review and drills.",
        url: "https://docs.google.com/document/d/1eam_3cZFxgSZ_vCvI9Zp5QoXYIjs5c3avjcTwPU6Ap4/edit?tab=t.0"
      },
      "Melee TV": {
        title: "Melee.tv",
        description:
          "Setup + community hub: Slippi, controller/adapters, optimization tips, Discords, event calendars, and more.",
        url: "https://melee.tv/"
      }
    };


    return (
        <div className="wrapper">
            <div id="content-wrap">
                <Navbar />
                <div className="d-flex flex-column justify-content-center align-items-center pt-md-5" style={{marginTop: "50px"}}>
                  {/* <div className='d-flex flex-wrap justify-content-center gap-4 pt-4'> */}
                      <h2>Resources</h2>
                      <p className='col-10 col-md-8 col-lg-10 text-center'>Enhance your learning experience with these valuable resources, freely accessible to everyone.</p>
                      <div className='d-flex pt-2'>
                          <img src={Shine} alt='Shine' className='pe-1' />
                          <img src={Shine} alt='Shine' className='pe-1' />
                          <img src={Shine} alt='Shine' className='pe-1' />
                      </div>
                      <div className='container'>
                        <div className='row justify-content-md-start justify-content-center pt-4'>
                          <div className='col-10 col-md-6 col-lg-4 mb-4 d-flex align-items-stretch' style={{cursor: 'pointer'}} onClick={() => window.open(resources["SSBM Tutorials"].url, '_blank')}>
                            <div className="bg-black rounded" style={{border: "1px solid white"}}>
                                <img src="https://ma-images.s3.us-east-1.amazonaws.com/thumbnails/ssbm-tutorials.png" style={{width: '100%', objectFit: 'cover'}} alt="Brick Wall" />
                                <div style={{padding: "20px 20px"}}>
                                    <h4>{resources["SSBM Tutorials"].title}</h4>
                                    <p>{resources["SSBM Tutorials"].description}</p>
                                </div>
                            </div>
                          </div>
                          <div className='col-10 col-md-6 col-lg-4 mb-4 d-flex align-items-stretch' style={{cursor: 'pointer'}} onClick={() => window.open(resources["LloD's Guide"].url, '_blank')}>
                            <div className="bg-black rounded" style={{border: "1px solid white"}}>
                                <img src="https://ma-images.s3.us-east-1.amazonaws.com/thumbnails/llods-guide.png" style={{width: '100%', objectFit: 'cover'}} alt="Brick Wall" />
                                <div style={{padding: "20px 20px"}}>
                                    <h4>{resources["LloD's Guide"].title}</h4>
                                    <p>{resources["LloD's Guide"].description}</p>
                                </div>
                            </div>
                          </div>
                          <div className='col-10 col-md-6 col-lg-4 mb-4 d-flex align-items-stretch' style={{cursor: 'pointer'}} onClick={() => window.open(resources["KoDoRiN's Guide"].url, '_blank')}>
                            <div className="bg-black rounded" style={{border: "1px solid white"}}>
                                <img src="https://ma-images.s3.us-east-1.amazonaws.com/thumbnails/kodorin-guide.png" style={{width: '100%', objectFit: 'cover'}} alt="Brick Wall" />
                                <div style={{padding: "20px 20px"}}>
                                    <h4>{resources["KoDoRiN's Guide"].title}</h4>
                                    <p>{resources["KoDoRiN's Guide"].description}</p>
                                </div>
                            </div>
                          </div>
                          <div className='col-10 col-md-6 col-lg-4 mb-4 d-flex align-items-stretch' style={{cursor: 'pointer'}} onClick={() => window.open(resources["Melee TV"].url, '_blank')}>
                            <div className="bg-black rounded" style={{border: "1px solid white"}}>
                                <img src="https://ma-images.s3.us-east-1.amazonaws.com/thumbnails/melee-tv.png" style={{width: '100%', objectFit: 'cover'}} alt="Brick Wall" />
                                <div style={{padding: "20px 20px"}}>
                                    <h4>{resources["Melee TV"].title}</h4>
                                    <p>{resources["Melee TV"].description}</p>
                                </div>
                            </div>
                          </div>
                          {/* <div className='col-10 col-md-6 col-lg-4 mb-4'>
                            <div className="bg-black rounded" style={{border: "1px solid white"}}>
                                <img src={Placeholder} style={{width: '100%', objectFit: 'cover'}} alt="Brick Wall" />
                                <div style={{padding: "20px 20px"}}>
                                    <h4>Core concepts covered</h4>
                                    <p>Get all the building blocks you need to be proficient in today's meta.</p>
                                </div>
                            </div>
                          </div> */}
                        </div>
                      </div>
                  {/* </div> */}
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Pricing;